// extracted by mini-css-extract-plugin
export var copySuccess = "ClipboardButton-module--copy-success--e2048";
export var copyWrapper = "ClipboardButton-module--copy-wrapper--e75f0";